import React from "react";
import styled from "styled-components";
const StyledLeft = styled.div`
  width: 50%;
  padding: 3rem;
  padding-top: 0;
`;
export default function RightCol(props) {
  return <StyledLeft className="tt-layout-right">{props.children}</StyledLeft>;
}
